import '@fontsource-variable/inter' // Supports weights 100-900
import '@fontsource-variable/open-sans' // Supports weights 300-800

import React from 'react'
import ReactDOM from 'react-dom/client'

import { replayIntegration, tanstackRouterBrowserTracingIntegration } from '@sentry/react'

import { initSentry } from './sentry/initSentry.ts'
import { App } from './App.tsx'
import { router } from './router.ts'

import './index.css'
// Supports weights 100-900

initSentry([
  replayIntegration({
    maskAllText: false,
    blockAllMedia: false,
  }),
  tanstackRouterBrowserTracingIntegration(router),
])

ReactDOM.createRoot(document.querySelector('#root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
